import { commaingNumber } from '../../utils'

const invoiceBreakUpPpuSchema = (data) => {
  let gender = (data.gender || '').trim().toLowerCase()
  gender = gender.length > 1 ? (gender[0].toUpperCase()) + gender.slice(1) : ''
  return (
    <tr>
      <td style={{width: '25%'}}>{data.package_name}</td>
      <td style={{width: '11%'}}>{data.taken_by} employees</td>
      <td style={{width: '8%'}}>{data.gender}</td>
      <td style={{width: '14%'}}>{data.provider_type}</td>
      <td style={{width: '20%'}}>₹{commaingNumber(data.cost)} / emp</td>
      <td style={{width: '11%'}}>{ data.gst_amount > 0 ? '₹' + commaingNumber(data.gst_amount) : 'Exempt IGST'}</td>
      <td style={{width: '11%'}}>₹{commaingNumber(data.total_cost)}</td>
    </tr>
  )
}

const invoiceBreakUpSubscriptionSchema = (data) => {
  return (
    <tr>
      <td>{data.taken_by} emp</td>
      <td>₹{commaingNumber(data.rate)} / emp</td>
      <td style={{width: '11%'}}>{ data.gst_amount > 0 ? '₹' + commaingNumber(data.gst_amount) : 'Exempt IGST'}</td>
      <td>₹{commaingNumber(data.total_cost)}</td>
    </tr>
  )
}

const invoiceBreakUpEmployeeSchema = (data) => {
  return (
    <tr>
      <td style={{width: '24%'}}>{data.taken_by}</td>
      <td style={{width: '19%'}}>₹{commaingNumber(data.rate)}</td>
      <td style={{width: '19%'}}>₹{commaingNumber(data.cost)}</td>
      <td style={{width: '11%'}}>{ data.gst_amount > 0 ? '₹' + commaingNumber(data.gst_amount) : 'Exempt IGST'}</td>
      <td style={{width: '19%'}}>₹{commaingNumber(data.total_cost)}</td>
    </tr>
  )
}

const invoiceBreakUpHealthCoachSchema = (data) => {
  return (
    <tr>
      <td>{data.package_name}</td>
      <td>{data.taken_by} emp</td>
      <td>₹{commaingNumber(data.cost)} / emp</td>
      <td style={{width: '11%'}}>{ data.gst_amount > 0 ? '₹' + commaingNumber(data.gst_amount) : 'Exempt IGST'}</td>
      <td>₹{commaingNumber(data.total_cost)}</td>
    </tr>
  )
}

const invoiceBreakUpSchema = (service = '', data = {}) => {
  service = service.toLowerCase()
  if(['health checks', 'vaccination', 'vision', 'dental', 'onsite', 'engagement activity', 'ohc'].includes(service)) return invoiceBreakUpPpuSchema(data)
  else if(['doctor consultation', 'opd', 'ewap', 'smart cover', 'gym'].includes(service)) return invoiceBreakUpSubscriptionSchema(data)
  else if(['health coach'].includes(service)) return invoiceBreakUpHealthCoachSchema(data)
  else if(['employee addition'].includes(service)) return invoiceBreakUpEmployeeSchema(data)
  
  return ''
}

export default invoiceBreakUpSchema